import { c, classy, m } from '@onfido/castor';
import React, { useState } from 'react';
import { createEventHook } from '../../utils';
import { Popover } from '../popover/popover';
export function Tooltip({ className, show, target, ...props }) {
    const [hover, setHover] = useState(false);
    // `show="on-hover"` can't be CSS only inside a Portal because the target is
    // no longer a sibling, so we listen to events on `target` instead
    useOnInteract(() => {
        var _a;
        setHover(!!((_a = target === null || target === void 0 ? void 0 : target.current) === null || _a === void 0 ? void 0 : _a.matches(':hover, :focus')));
    }, [target]);
    const showModifier = show === 'on-hover'
        ? target
            ? { show: hover }
            : show
        : { show: show === true };
    return (React.createElement(Popover, { ...props, className: classy(c('tooltip'), m(showModifier), className), target: target }));
}
const useOnInteract = createEventHook([
    'focus',
    'blur',
    'mouseenter',
    'mouseleave',
    'touchstart',
    'touchend',
]);
//# sourceMappingURL=tooltip.js.map